import React from 'react';
import { ConfirmModalState } from '../../types/dispense';

interface ConfirmModalProps {
  confirmModal: ConfirmModalState;
  onDismiss: () => void;
}

export function ConfirmModal({ confirmModal, onDismiss }: ConfirmModalProps) {
  if (!confirmModal.show) return null;

  return (
    <div
      className="modal-overlay"
      onClick={() => {
        if (confirmModal.onCancel) {
          confirmModal.onCancel();
        } else {
          onDismiss();
        }
      }}
      style={{ zIndex: 3000 }}
    >
      <div className="modal modal-alert" onClick={(e) => e.stopPropagation()}>
        <div className="alert-icon alert-icon-info">⚠</div>
        <div className="alert-message">{confirmModal.message}</div>
        <div className="modal-actions">
          {confirmModal.onCancel && (
            <button
              className="btn btn-secondary"
              onClick={() => {
                if (confirmModal.onCancel) confirmModal.onCancel();
              }}
            >
              Cancel
            </button>
          )}
          <button
            className={`btn ${confirmModal.confirmStyle || 'btn-danger'}`}
            onClick={() => {
              confirmModal.onConfirm();
            }}
          >
            {confirmModal.confirmText || 'Remove'}
          </button>
        </div>
      </div>
    </div>
  );
}
